/* tslint:disable */
/* eslint-disable */
/**
 * NN.CustomerPortal.ApiApp.General
 * GeneralAPIs
 *
 * The version of the OpenAPI document: 1.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SendAuthenticationSMSResponse
 */
export interface SendAuthenticationSMSResponse {
    /**
     * 
     * @type {string}
     * @memberof SendAuthenticationSMSResponse
     */
    transactionId: string;
    /**
     * 
     * @type {string}
     * @memberof SendAuthenticationSMSResponse
     */
    phoneNumber: string;
}

/**
 * Check if a given object implements the SendAuthenticationSMSResponse interface.
 */
export function instanceOfSendAuthenticationSMSResponse(value: object): value is SendAuthenticationSMSResponse {
    if (!('transactionId' in value) || value['transactionId'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    return true;
}

export function SendAuthenticationSMSResponseFromJSON(json: any): SendAuthenticationSMSResponse {
    return SendAuthenticationSMSResponseFromJSONTyped(json, false);
}

export function SendAuthenticationSMSResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SendAuthenticationSMSResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionId': json['transactionId'],
        'phoneNumber': json['phoneNumber'],
    };
}

export function SendAuthenticationSMSResponseToJSON(json: any): SendAuthenticationSMSResponse {
    return SendAuthenticationSMSResponseToJSONTyped(json, false);
}

export function SendAuthenticationSMSResponseToJSONTyped(value?: SendAuthenticationSMSResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionId': value['transactionId'],
        'phoneNumber': value['phoneNumber'],
    };
}

